import { render, staticRenderFns } from "./EnderecoBairroField.vue?vue&type=template&id=501e31fd&scoped=true&"
import script from "./EnderecoBairroField.vue?vue&type=script&lang=js&"
export * from "./EnderecoBairroField.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoBairroField.vue?vue&type=style&index=0&id=501e31fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e31fd",
  null
  
)

export default component.exports